// move to config and use env variables
export const firebaseConfig = {
	apiKey: 'AIzaSyDWxbiUuoh8N6UtFoSxmRXxKiGAYzsJFz4',
	projectId: 'codigo-hub-prod',
	authDomain: 'apiprod.codigohub.dev/authv2/accounts',
	appId: '1:777834302620:web:ba28d206fa6cdd656ef159'
}

export const defaultTenantId = 'codigo-web-0x59n'
